var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24.1875C20.5218 24.1875 24.1875 20.5218 24.1875 16C24.1875 11.4782 20.5218 7.8125 16 7.8125C11.4782 7.8125 7.8125 11.4782 7.8125 16C7.8125 20.5218 11.4782 24.1875 16 24.1875ZM16 21.3125C18.934 21.3125 21.3125 18.934 21.3125 16C21.3125 13.066 18.934 10.6875 16 10.6875C13.066 10.6875 10.6875 13.066 10.6875 16C10.6875 18.934 13.066 21.3125 16 21.3125Z",
    fill: "var(--template-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5156 9.40625C25.577 9.40625 26.4375 8.5458 26.4375 7.48438C26.4375 6.42295 25.577 5.5625 24.5156 5.5625C23.4542 5.5625 22.5938 6.42295 22.5938 7.48438C22.5938 8.5458 23.4542 9.40625 24.5156 9.40625Z",
    fill: "var(--template-primary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.125 0C4.0854 0 0 4.0854 0 9.125V22.875C0 27.9146 4.0854 32 9.125 32H22.875C27.9146 32 32 27.9146 32 22.875V9.125C32 4.0854 27.9146 0 22.875 0H9.125ZM9.125 2.875C5.67322 2.875 2.875 5.67322 2.875 9.125V22.875C2.875 26.3268 5.67322 29.125 9.125 29.125H22.875C26.3268 29.125 29.125 26.3268 29.125 22.875V9.125C29.125 5.67322 26.3268 2.875 22.875 2.875H9.125Z",
    fill: "var(--template-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.9e48dcbb5036fcdd62532a45e4aa0d92.svg";
export { ForwardRef as ReactComponent };